import IntegralList from './integral-list'
export default IntegralList